import Vue from 'vue'
import VueSweetalert2 from 'vue-sweetalert2';
Vue.use(VueSweetalert2);
import VueRouter from 'vue-router'
import store from '@/helpers/store'
import Register from '@/pages/UserManager/Register'
import Login from '@/pages/UserManager/Login'
import ForgotPassword from '@/pages/UserManager/ForgotPassword'
import ContulMeu from '@/pages/Home/ContulMeu/ContulMeu'
import Aplicatii from '@/pages/Aplicatii/Aplicatii'
import ErrorPage from '@/pages/404/ErrorPage'
import PageClosed from '@/pages/PageClosed/PageClosed'
import M3Status from '@/pages/Aplicatii/M3/M3Status/M3Status'
import M3Sketch from '@/pages/Aplicatii/M3/M3Sketch/M3Sketch'
import MySMIS from '@/pages/Aplicatii/M3/M3Sketch/pages/MySMIS'
import Checklist from '@/pages/Aplicatii/M3/M3Sketch/pages/Checklist'
import DosarulTauComplet from '@/pages/Aplicatii/M3/M3Sketch/pages/DosarulTauComplet'
import CompaniaMea from '@/pages/Aplicatii/M3/M3Sketch/pages/CompaniaMea'
import ResetPassword from '@/pages/UserManager/ResetPassword'
import ProiectulMeu from '@/pages/Aplicatii/M3/M3Sketch/pages/ProiectulMeu'
import Activitati from '@/pages/Aplicatii/M3/M3Sketch/pages/Activitati'
import Obiective from '@/pages/Aplicatii/M3/M3Sketch/pages/Obiective'
import Indicatori from '@/pages/Aplicatii/M3/M3Sketch/pages/Indicatori'
import AchizitiiCheltuieli from '@/pages/Aplicatii/M3/M3Sketch/pages/AchizitiiCheltuieli'
import Buget from '@/pages/Aplicatii/M3/M3Sketch/pages/Buget'
import PlanAfaceri from '@/pages/Aplicatii/M3/M3Sketch/pages/PlanAfaceri'
import SintezaProiect from '@/pages/Aplicatii/M3/M3Sketch/pages/SintezaProiect'
import TutorialeMySmis from '@/pages/Aplicatii/M3/M3Sketch/pages/TutorialeMySmis'
import ProiectMySmis from '@/pages/Aplicatii/M3/M3Sketch/pages/ProiectMySmis'
import ProiectGranturiIMM from '@/pages/Aplicatii/M3/M3Sketch/pages/ProiectGranturiIMM'
import TutorialAplicare from '@/pages/Aplicatii/M3/M3Sketch/pages/TutorialAplicare'
import ProiectulTauMySmis from '@/pages/Aplicatii/M3/M3Sketch/pages/ProiectulTauMySmis'
import Solicitant from '@/pages/Aplicatii/M3/M3Sketch/components/mysmis/components/Solicitant'
import IMMDepunere from '@/pages/Aplicatii/M3/M3Sketch/components/granturi-imm/components/IMMDepunere'
import IMMClarificari from '@/pages/Aplicatii/M3/M3Sketch/components/granturi-imm/components/IMMClarificari'
import IMMContestatii from '@/pages/Aplicatii/M3/M3Sketch/components/granturi-imm/components/IMMContestatii'
import AtributeProiect from '@/pages/Aplicatii/M3/M3Sketch/components/mysmis/components/AtributeProiect'
import ProblemaAplicatie from '@/pages/Aplicatii/M3/M3Sketch/pages/ProblemaAplicatie'
import IntrebariFrecvente from '@/pages/Aplicatii/M3/M3Sketch/pages/IntrebariFrecvente'
import ProblemaSingle from '@/pages/Aplicatii/M3/M3Sketch/components/probleme-aplicatie/ProblemaSingle'
import ToateCompaniile from '@/pages/Aplicatii/M3/M3Sketch/pages/ToateCompaniile'
import CumparaLicenta from '@/pages/Aplicatii/M3/M3Sketch/pages/CumparaLicenta'
import ComandaLicenta from '@/pages/Aplicatii/M3/M3Sketch/components/cumpara-licenta/ComandaLicenta'
import LicenteleMele from '@/pages/Aplicatii/M3/M3Sketch/components/cumpara-licenta/LicenteleMele'
import ContracteFacturi from '@/pages/Aplicatii/M3/M3Sketch/components/cumpara-licenta/ContracteFacturi'
import Neautorizat from '@/pages/Aplicatii/M3/M3Sketch/components/Neautorizat'
import IMMRecover from "@/pages/Aplicatii/M3/M3Sketch/pages/IMMRecover"
import AchizitiiVerzi from "@/pages/Aplicatii/M3/M3Sketch/pages/AchizitiiVerzi";
import DocumenteUtile from "@/pages/Aplicatii/M3/M3Sketch/pages/DocumenteUtile";
import Notificari from "@/pages/Aplicatii/M3/M3Sketch/pages/Notificari";

// Cerere de finantare

import CerereDeFinantare from '@/pages/Aplicatii/M3/M3Sketch/pages/CerereDeFinantare'
import CFSolicitant from '@/pages/Aplicatii/M3/M3Sketch/components/cerere-finantare/CFSolicitant'
import CFAtributeProiect from '@/pages/Aplicatii/M3/M3Sketch/components/cerere-finantare/CFAtributeProiect'
import CFResponsabilProiect from '@/pages/Aplicatii/M3/M3Sketch/components/cerere-finantare/CFResponsabilProiect'
import CFPersoanaDeContact from '@/pages/Aplicatii/M3/M3Sketch/components/cerere-finantare/CFPersoanaDeContact'
import CFCapacitateSolicitant from '@/pages/Aplicatii/M3/M3Sketch/components/cerere-finantare/CFCapacitateSolicitant'
import CFLocalizareProiect from '@/pages/Aplicatii/M3/M3Sketch/components/cerere-finantare/CFLocalizareProiect'
import CFSustenabilitate from '@/pages/Aplicatii/M3/M3Sketch/components/cerere-finantare/CFSustenabilitate'
import CFRiscuri from '@/pages/Aplicatii/M3/M3Sketch/components/cerere-finantare/CFRiscuri'
import CFPrincipiiOrizontale from '@/pages/Aplicatii/M3/M3Sketch/components/cerere-finantare/CFPrincipiiOrizontale'
import CFMetodologie from '@/pages/Aplicatii/M3/M3Sketch/components/cerere-finantare/CFMetodologie'
import CFDescriereaInvestitiei from '@/pages/Aplicatii/M3/M3Sketch/components/cerere-finantare/CFDescriereaInvestitiei'
import CFRezultateAsteptate from '@/pages/Aplicatii/M3/M3Sketch/components/cerere-finantare/CFRezultateAsteptate'
import CFMaturitateaProiectului from '@/pages/Aplicatii/M3/M3Sketch/components/cerere-finantare/CFMaturitateaProiectului'
import CFNerespectareLegislatieUE from '@/pages/Aplicatii/M3/M3Sketch/components/cerere-finantare/CFNerespectareLegislatieUE'
import CFObiectiveProiect from '@/pages/Aplicatii/M3/M3Sketch/components/cerere-finantare/CFObiectiveProiect'
import CFIndicatoriPrestabiliti from '@/pages/Aplicatii/M3/M3Sketch/components/cerere-finantare/CFIndicatoriPrestabiliti'
import CFBugetTipFinantare from '@/pages/Aplicatii/M3/M3Sketch/components/cerere-finantare/CFBugetTipFinantare'
import CFCampInterventie from '@/pages/Aplicatii/M3/M3Sketch/components/cerere-finantare/CFCampInterventie'
import CFBugetAmplasament from '@/pages/Aplicatii/M3/M3Sketch/components/cerere-finantare/CFBugetAmplasament'
import CFBugetPlanAnualCheltuieli from '@/pages/Aplicatii/M3/M3Sketch/components/cerere-finantare/CFBugetPlanAnualCheltuieli'
import CFBugetActivitatiCheltuieli from '@/pages/Aplicatii/M3/M3Sketch/components/cerere-finantare/CFBugetActivitatiCheltuieli'
import CFActivitatiPrevizionate from '@/pages/Aplicatii/M3/M3Sketch/components/cerere-finantare/CFActivitatiPrevizionate'
import CFResurseMateriale from '@/pages/Aplicatii/M3/M3Sketch/components/cerere-finantare/CFResurseMateriale'
import CFResurseUmane from '@/pages/Aplicatii/M3/M3Sketch/components/cerere-finantare/CFResurseUmane'
import CFPlanAchizitii from '@/pages/Aplicatii/M3/M3Sketch/components/cerere-finantare/CFPlanAchizitii'
import CFIndicatoriSuplimentari from '@/pages/Aplicatii/M3/M3Sketch/components/cerere-finantare/CFIndicatoriSuplimentari'
import CFJustificare from '@/pages/Aplicatii/M3/M3Sketch/components/cerere-finantare/CFJustificare'
import CFContext from '@/pages/Aplicatii/M3/M3Sketch/components/cerere-finantare/CFContext'

import middleware from '@/helpers/middleware'

Vue.use(VueRouter)
import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)

const routes = [
    {
        path: "/",
        redirect: "/aplicatii/m3-status",
        name: "Homepage",
        component: M3Status,
        beforeEnter: middleware.auth,
    },
    {
        path: "/aplicatii/m3-status",
        name: "M3Status",
        component: M3Status,
        beforeEnter: middleware.auth,
    },
    {
        path: "/tichete-suport",
        name: "ProblemaAplicatie",
        component: ProblemaAplicatie,
    },
    {
        path: "/intrebari-frecvente",
        name: "IntrebariFrecvente",
        component: IntrebariFrecvente,
    },
    {
        path: "/notificari",
        name: "Notificari",
        component: Notificari,
    },
    {
        path: "/tichete-suport/:id",
        name: "ProblemaSingle",
        component: ProblemaSingle,
    },
    {
        path: "/licente",
        redirect: "/licente/comanda-licenta",
        name: "CumparaLicenta",
        component: CumparaLicenta,
        children: [
            {
                path: "comanda-licenta",
                name: "ComandaLicenta",
                component: ComandaLicenta,
            },
            {
                path: "licentele-mele",
                name: "LicenteleMele",
                component: LicenteleMele,
            },
            {
                path: "contracte-facturi",
                name: "ContracteFacturi",
                component: ContracteFacturi,
            },
        ]
    },
    // {
    //     path: "/aplicatii/m3-sketch",
    //     name: "M3SketchComingSoon",
    //     component: M3SketchComingSoon,
    //     beforeEnter: middleware.m3HasCompany,
    // },
    {
        path: "/aplicatii/m3-manager",
        component: PageClosed,
        beforeEnter: middleware.auth,
    },
    {
        // path: "/aplicatii/m3-sketch",
        path: "/aplicatii/m3-sketch",
        redirect: "/aplicatii/m3-sketch/imm-recover",
        name: "M3Sketch",
        component: M3Sketch,
        children: [
            {
                path: "cont-mysmis",
                name: "Cont MySMIS",
                component: MySMIS,
                beforeEnter: middleware.m3HasCompany,

            },
            {
                path: "imm-recover",
                name: "ImmRecover",
                component: IMMRecover,
                beforeEnter: middleware.m3HasCompany,

            },
            {
                path: "notificari",
                name: "M3SketchNotificari",
                component: Notificari,
                beforeEnter: middleware.m3HasCompany,

            },
            {
                path: "neautorizat",
                name: "Neautorizat",
                component: Neautorizat,
            },
            {
                path: "platforma-mysmis",
                name: "MySMIS",
                component: MySMIS,
                beforeEnter: middleware.m3HasCompany,
            },
            {
                path: "checklist",
                name: "Checklist",
                component: Checklist,
                beforeEnter: middleware.m3HasCompany,
            },
            {
                path: "compania-mea",
                name: "CompaniaMea",
                component: CompaniaMea,
                props: (route) => ({ query: route.query.allData }),
                beforeEnter: middleware.m3HasCompany,
            },
            {
                path: "proiectul-meu",
                name: "ProiectulMeu",
                component: ProiectulMeu,
                beforeEnter: middleware.m3HasCompany,
            },
            {
                path: "activitati",
                name: "Activitati",
                component: Activitati,
                beforeEnter: middleware.m3HasCompany,
            },
            {
                path: "achizitii-cheltuieli",
                name: "AchizitiiCheltuieli",
                component: AchizitiiCheltuieli,
                beforeEnter: middleware.m3HasCompany,
            },
            {
                path: "obiective",
                name: "Obiective",
                component: Obiective,
                beforeEnter: middleware.m3HasCompany,
            },
            {
                path: "indicatori",
                name: "Indicatori",
                component: Indicatori,
                beforeEnter: middleware.m3HasCompany,
            },
            {
                path: "dosarul-tau",
                name: "DosarulTauComplet",
                component: DosarulTauComplet,
                beforeEnter: middleware.m3HasCompany,
            },
            {
                path: "buget",
                name: "Buget",
                component: Buget,
                beforeEnter: middleware.m3HasCompany,
            },
            {
                path: "plan-de-afaceri",
                name: "PlanAfaceri",
                component: PlanAfaceri,
                beforeEnter: middleware.m3HasCompany,
            },
            {
                path: "cerere-de-finantare",
                redirect: "/aplicatii/m3-sketch/cerere-de-finantare/solicitant",
                name: "CerereDeFinantare",
                component: CerereDeFinantare,
                beforeEnter: middleware.m3HasCompany,
                children: [
                    {
                        path: "solicitant",
                        name: "CFSolicitant",
                        component: CFSolicitant,
                    },
                    {
                        path: "atribute-proiect",
                        name: "CFAtributeProiect",
                        component: CFAtributeProiect,
                    },
                    {
                        path: "responsabil-proiect",
                        name: "CFResponsabilProiect",
                        component: CFResponsabilProiect,
                    },
                    {
                        path: "persoana-de-contact",
                        name: "CFPersoanaDeContact",
                        component: CFPersoanaDeContact,
                    },
                    {
                        path: "capacitate-solicitant",
                        name: "CFCapacitateSolicitant",
                        component: CFCapacitateSolicitant,
                    },
                    {
                        path: "localizare-proiect",
                        name: "CFLocalizareProiect",
                        component: CFLocalizareProiect,
                    },
                    {
                        path: "obiective-proiect",
                        name: "CFObiectiveProiect",
                        component: CFObiectiveProiect,
                    },
                    {
                        path: "rezultate-asteptate",
                        name: "CFRezultateAsteptate",
                        component: CFRezultateAsteptate,
                    },
                    {
                        path: "context",
                        name: "CFContext",
                        component: CFContext,
                    },
                    {
                        path: "justificare",
                        name: "CFJustificare",
                        component: CFJustificare,
                    },
                    {
                        path: "sustenabilitate",
                        name: "CFSustenabilitate",
                        component: CFSustenabilitate,
                    },
                    {
                        path: "riscuri",
                        name: "CFRiscuri",
                        component: CFRiscuri,
                    },
                    {
                        path: "principii-orizontale",
                        name: "CFPrincipiiOrizontale",
                        component: CFPrincipiiOrizontale,
                    },
                    {
                        path: "metodologie",
                        name: "CFMetodologie",
                        component: CFMetodologie,
                    },
                    {
                        path: "descrierea-investitiei",
                        name: "CFDescriereaInvestitiei",
                        component: CFDescriereaInvestitiei,
                    },
                    {
                        path: "maturitatea-proiectului",
                        name: "CFMaturitateaProiectului",
                        component: CFMaturitateaProiectului,
                    },
                    {
                        path: "nerespectare-legislatie-ue",
                        name: "CFNerespectareLegislatieUE",
                        component: CFNerespectareLegislatieUE,
                    },
                    {
                        path: "indicatori-prestabiliti",
                        name: "CFIndicatoriPrestabiliti",
                        component: CFIndicatoriPrestabiliti,
                    },
                    {
                        path: "indicatori-suplimentari",
                        name: "CFIndicatoriSuplimentari",
                        component: CFIndicatoriSuplimentari,
                    },
                    {
                        path: "plan-achizitii",
                        name: "CFPlanAchizitii",
                        component: CFPlanAchizitii,
                    },
                    {
                        path: "resurse-umane",
                        name: "CFResurseUmane",
                        component: CFResurseUmane,
                    },
                    {
                        path: "resurse-materiale",
                        name: "CFResurseMateriale",
                        component: CFResurseMateriale,
                    },
                    {
                        path: "activitati-previzionate",
                        name: "CFActivitatiPrevizionate",
                        component: CFActivitatiPrevizionate,
                    },
                    {
                        path: "buget-activitati-cheltuieli",
                        name: "CFBugetActivitatiCheltuieli",
                        component: CFBugetActivitatiCheltuieli,
                    },
                    {
                        path: "buget-plan-anual-cheltuieli",
                        name: "CFBugetPlanAnualCheltuieli",
                        component: CFBugetPlanAnualCheltuieli,
                    },
                    {
                        path: "buget-amplasament",
                        name: "CFBugetAmplasament",
                        component: CFBugetAmplasament,
                    },
                    {
                        path: "buget-camp-interventie",
                        name: "CFCampInterventie",
                        component: CFCampInterventie,
                    },
                    {
                        path: "buget-tip-finantare",
                        name: "CFBugetTipFinantare",
                        component: CFBugetTipFinantare,
                    },
                ]
            },
            {
                path: "proiectul-tau-mysmis",
                name: "ProiectulTauMySmis",
                component: ProiectulTauMySmis,
                beforeEnter: middleware.m3HasCompany,
            },
            {
                path: "sinteza",
                name: "SintezaProiect",
                component: SintezaProiect,
                beforeEnter: middleware.m3HasCompany,
            },
            {
                path: "tutoriale",
                name: "TutorialeMySmis",
                component: TutorialeMySmis,
                beforeEnter: middleware.m3HasCompany,
            },
            {
                path: "tutorial-aplicare",
                name: "TutorialAplicare",
                component: TutorialAplicare,
                beforeEnter: middleware.m3HasCompany,
            },
            {
                path: "achizitii-verzi",
                name: "AchizitiiVerzi",
                component: AchizitiiVerzi,
                beforeEnter: middleware.m3HasCompany,
            },
            {
                path: "documente-utile",
                name: "DocumenteUtile",
                component: DocumenteUtile,
                beforeEnter: middleware.m3HasCompany,
            },
            {
                path: "/aplicatii/m3-sketch/tichete-suport",
                name: "ProblemaAplicatieSketch",
                component: ProblemaAplicatie,
            },
            {
                path: "/aplicatii/m3-sketch/intrebari-frecvente",
                name: "IntrebariFrecventeSketch",
                component: IntrebariFrecvente,
            },
            {
                path: "/aplicatii/m3-sketch/tichete-suport/:id",
                name: "ProblemaSingleSketch",
                component: ProblemaSingle,
            },
            {
                path: "dashboard-proiecte",
                name: "ToateCompaniile",
                component: ToateCompaniile,
                beforeEnter: middleware.m3HasCompany,
            },
            {
                path: "/aplicatii/m3-sketch/licente",
                redirect: "/aplicatii/m3-sketch/licente/comanda-licenta",
                name: "M3SketchCumparaLicenta",
                component: CumparaLicenta,
                children: [
                    {
                        path: "comanda-licenta",
                        name: "M3SketchComandaLicenta",
                        component: ComandaLicenta,
                    },
                    {
                        path: "licentele-mele",
                        name: "M3SketchLicenteleMele",
                        component: LicenteleMele,
                    },
                    {
                        path: "contracte-facturi",
                        name: "M3SketchContracteFacturi",
                        component: ContracteFacturi,
                    },
                ]
            },
            {
                path: "proiect-mysmis",
                redirect: "proiect-mysmis/solicitant",
                name: "ProiectMySmis",
                component: ProiectMySmis,
                beforeEnter: middleware.m3HasCompany,
                children: [
                    {
                        path: "solicitant",
                        name: "Solicitant",
                        component: Solicitant,
                    },
                    {
                        path: "atribute-proiect",
                        name: "AtributeProiect",
                        component: AtributeProiect,
                    },
                ]
            },
            {
                path: "proiect-granturi-imm",
                redirect: "proiect-granturi-imm/depunere",
                name: "ProiectGranturiIMM",
                component: ProiectGranturiIMM,
                beforeEnter: middleware.m3HasCompany,
                children: [
                    {
                        path: "depunere",
                        name: "Depunere",
                        component: IMMDepunere,
                    },
                    {
                        path: "clarificari",
                        name: "Clarificari",
                        component: IMMClarificari,
                    },
                    {
                        path: "contestatii",
                        name: "Contestatii",
                        component: IMMContestatii,
                    }
                ]
            },
        ]
    },
    {
        path: "/register",
        name: "Register",
        component: Register,
        beforeEnter: middleware.guest,
    },
    {
        path: "/login",
        name: "Login",
        component: Login,
        beforeEnter: middleware.guest,
    },
      {
        path: "/email/verify/*",
        name: "EmailVerify",
        component: Login,
        beforeEnter: middleware.guest,
    },
    {
        path: "/forgot-password",
        name: "ForgotPassword",
        component: ForgotPassword,
        beforeEnter: middleware.guest,
    },
    {
        path: "/reset-password/*",
        name: "ResetPassword",
        component: ResetPassword,
        beforeEnter: middleware.guest,
    },
    {
        path: "/contul-meu",
        name: "ContulMeu",
        component: ContulMeu,
        beforeEnter: middleware.auth,
    },
    {
        path: "/aplicatii",
        name: "Aplicatii",
        component: Aplicatii,
        beforeEnter: middleware.auth,
    },
    {
        path: "/termene",
        name: "Termene",
        component: PageClosed,
    },
    {
        path: "/*/in-constructie",
        name: "In curand",
        component: PageClosed,
    },
    {
        path: "*",
        component: ErrorPage,
    }
];



const router = new VueRouter({
    mode: 'history',
    //base: process.env.BASE_URL,
    routes
})

router.beforeEach((to, from, next) => {
    let deny = [
        'login',
        'register',
        'forgot-password',
        'email/verify',
        'reset-password'
    ]
    let show = true
    deny.forEach(path => {
        if(to.fullPath.includes(path))
            show = false
    })

    if (show)
        getNotifications()

    next()

})

function getNotifications() {
    store.dispatch('notifications/initializeNotifications')
}

export default router
